const fonts = {
  kardabel: 'Reem Kufi, sans-serif',
  titles: 'Outfit, sans-serif',
  txt: 'Urbanist, sans-serif',
  signature: 'Hearth Stone, cursive',
  titles2: 'delittle-chromatic, sans-serif',
}

export default fonts